if($('footer#footer').length){
    $('#signature').removeAttr('style').html('<a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="title" target="_blank">Vytvořil Shoptet</a> <span class="dostmedia"> | <a href="https://www.dostmedia.cz/" target="_blank">Dostmedia</a></span>')
    $('#signature').prepend($('footer#footer .payment'));
    $('footer#footer .contact-box').after($('footer#footer .moreContact'))
    $('footer#footer').before($('footer#footer .customInstagram'))
    $(".instagram-widget>a").each(function(){
        $(".instagramFeed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    $('header#header .header-top').append($('footer#footer .familyFirm'))
    $(document).on('click', '.displayIframeMap', function(){
        $.colorbox({
            html: $('footer#footer .footerIframe').closest('span').html(),
            width: 600,
            maxWidth: "90%",
            height: 600,
            maxHeight: "90%",
            className: "iframeMap",
            onComplete: function() {
                
            },
        });
    })
}